"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteRelationType = void 0;
var NoteRelationType;
(function (NoteRelationType) {
    NoteRelationType["Location"] = "Location";
    NoteRelationType["Remediation"] = "Remediation";
})(NoteRelationType = exports.NoteRelationType || (exports.NoteRelationType = {}));
//# sourceMappingURL=NoteRelationType.js.map